import { render, staticRenderFns } from "./BedbuilderMobileMenu.vue?vue&type=template&id=5a077297&"
import script from "./BedbuilderMobileMenu.vue?vue&type=script&lang=js&"
export * from "./BedbuilderMobileMenu.vue?vue&type=script&lang=js&"
import style0 from "./BedbuilderMobileMenu.vue?vue&type=style&index=0&id=5a077297&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BedbuilderPrint: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/bedbuilder/BedbuilderPrint.vue').default,BedbuilderShareOptions: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/bedbuilder/BedbuilderShareOptions.vue').default,SvgIconCircle: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconCircle.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
